import { render, staticRenderFns } from "./_Layout.vue?vue&type=template&id=8518c8e0&scoped=true&"
import script from "./_Layout.vue?vue&type=script&lang=js&"
export * from "./_Layout.vue?vue&type=script&lang=js&"
import style0 from "./_Layout.vue?vue&type=style&index=0&id=8518c8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8518c8e0",
  null
  
)

export default component.exports